import Navbar from "../components/marketing/Navbar";
import Hero from "../components/marketing/Hero";
import TrustBar from "../components/marketing/TrustBar";
import FeatureGrid from "../components/marketing/FeatureGrid";
import Marquee from "../components/marketing/Marquee";
import ProductTour from "../components/marketing/ProductTour";
import LeadManagement from "../components/marketing/LeadManagement";
import Pipeline from "../components/marketing/Pipeline";
import Automation from "../components/marketing/Automation";
import Engage from "../components/marketing/Engage";
import FieldSales from "../components/marketing/FieldSales";
import Manifesto from "../components/marketing/Manifesto";
import Industries from "../components/marketing/Industries";
import AISection from "../components/marketing/AISection";
import Ecosystem from "../components/marketing/Ecosystem";
import Pricing from "../components/marketing/Pricing";
import FAQ from "../components/marketing/FAQ";
import FinalCTA from "../components/marketing/FinalCTA";
import Footer from "../components/marketing/Footer";

export default function Home() {
    return (
        <div className="min-h-screen bg-white">
            <Navbar />
            <main>
                <Hero />
                <TrustBar />
                <FeatureGrid />
                <Marquee />
                <ProductTour />
                <LeadManagement />
                <Pipeline />
                <Automation />
                <Engage />
                <FieldSales />
                <Manifesto />
                <Industries />
                <AISection />
                <Ecosystem />
                <Pricing />
                <FAQ />
                <FinalCTA />
            </main>
            <Footer />
        </div>
    );
}
